import curry from "../../lib/core/functional/curry";

import { EVENTS } from "./_common";

const showMessage = curry(function showMessage(message, element) {
    element.classList.remove("hidden");
    element.textContent = message;
});

const displayEvent = curry(function displayEvent(elements, event) {
    elements.forEach(showMessage(event.detail.message || event.detail.error));
});

function hideElement(element) {
    element.classList.add("hidden");
}

const hideFeedback = curry(function hideFeedback(elements, _event) {
    elements.forEach(hideElement);
});

export default function prepare({ listicle, context }) {
    const errorElements = listicle.querySelectorAll(".listicle-item-voting-feedback-error");
    const successElements = listicle.querySelectorAll(".listicle-item-voting-feedback-success");

    listicle.addEventListener(EVENTS.VOTE_ERROR, displayEvent(errorElements));
    listicle.addEventListener(EVENTS.VOTE_SUCCESS, displayEvent(successElements));

    listicle.addEventListener(
        EVENTS.VOTE_CLEAR,
        hideFeedback([...errorElements, ...successElements])
    );
    return { listicle, context };
}
